import React from 'react';
import { COMPANY_NAME, LOGO_URL, PORTAL_LABEL } from '../../config/branding';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bg-surface)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '14px 32px',
      marginTop: 'auto',
    }}>
      <div style={{
        maxWidth: 1400,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src={LOGO_URL} alt={COMPANY_NAME} style={{ height: 30, objectFit: 'contain' }} />
          <span style={{ width: 1, height: 18, background: 'var(--n-200)', display: 'inline-block' }} />
          <span style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 500 }}>
            © {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.
          </span>
        </div>
        <span style={{
          fontSize: 11, color: 'var(--n-300)', fontWeight: 500, letterSpacing: .3,
        }}>
          {PORTAL_LABEL} v2.0
        </span>
      </div>
    </footer>
  );
}
